import ManagerSelect from './ManagerSelect';

export default ManagerSelect;
